import React from "react";

// Original two-tone line-art illustrations in RollOver colours.
// All use currentColor for strokes so they inherit the active theme.

export function Host({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 280 430" fill="none" aria-hidden="true">
      <g stroke="currentColor" strokeWidth="7" strokeLinejoin="round" strokeLinecap="round">
        <path d="M86 85Q55 62 76 34Q87 15 108 30Q124 0 148 19Q175 9 188 32Q218 28 214 58Q213 83 191 86Z" fill="#fff7df" />
        <path d="M100 83H187V113H100Z" fill="#ffbe22" />
        <path d="M110 114V167Q149 202 182 163V114" fill="#fff7df" />
        <path d="M113 179L78 209L68 301H212L201 208L177 178" fill="#55d4be" />
        <path d="M123 184V290H185V185M125 245H184" />
        <path d="M92 210L49 260L77 281L117 246M194 211L236 243L224 268L184 245" fill="#fff7df" />
        <path d="M82 301L83 389H123L140 304L157 389H201L203 301" fill="#087f83" />
        <path d="M83 389L66 409H126V389M157 389V409H218L201 389" fill="#ffbe22" />
        <path d="M125 136H127M163 136H165M131 158Q146 169 163 155M147 135V150" />
        <path d="M210 235H265M218 230Q239 207 259 230M214 268H268" />
      </g>
      <path d="M35 90l8-18 8 18 19 8-19 8-8 18-8-18-18-8z" fill="#ffbe22" />
      <circle cx="240" cy="135" r="9" fill="#55d4be" />
    </svg>
  );
}

export function Guest({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 300 430" fill="none" aria-hidden="true">
      <g stroke="currentColor" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M68 76Q69 15 135 25Q195 28 183 91" fill="#087f83" />
        <path d="M83 69L79 123Q124 164 169 119L173 65" fill="#fff7df" />
        <path d="M83 141L47 191L55 262L167 264L186 188L161 144" fill="#ffbe22" />
        <path d="M65 263L139 285L213 350L190 374L109 313L49 300" fill="#55d4be" />
        <path d="M58 300L89 373H135L117 303" fill="#087f83" />
        <path d="M89 373L80 397H151L135 373M190 374L199 402L245 371L212 350" fill="#fff7df" />
        <path d="M46 193L96 218L138 175L158 192L116 243L46 221" fill="#fff7df" />
        <path d="M150 165H192L185 204H156Z" fill="#fff7df" />
        <path d="M56 267H184V297H56M69 296V414M175 297V414M105 91H107M148 91H150M113 118Q131 132 149 114" />
        <path d="M156 163L168 146" />
      </g>
    </svg>
  );
}

const iconPaths = [
  '<path d="M12 47Q17 8 55 13Q93 13 98 47Z"/><path d="M12 60H98M14 74H96M13 85Q55 106 98 85V76H12Z"/><path d="M25 38l4-5M47 30l4-4M68 32l4 4M86 41l3-3"/>',
  '<path d="M24 46H86L78 99H33Z"/><path d="M23 45Q15 25 35 22Q37 3 55 11Q76 3 79 24Q99 26 87 45"/><path d="M38 59L70 85M71 59L41 87"/>',
  '<path d="M15 98V45L55 13L95 45V98Z"/><path d="M38 98V60H72V98M10 45H100M28 44V25M82 44V25"/><circle cx="55" cy="39" r="7"/>',
  '<path d="M30 17H78L86 96H21Z"/><path d="M27 43H82M45 17L55 2M34 67H72M34 82H64"/>',
];

export function BenefitIcon({ index, className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 110 110"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: iconPaths[index % iconPaths.length] }}
    />
  );
}

export function Utensil({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 450 140" fill="none" aria-hidden="true">
      <path
        d="M25 75Q-2 31 44 16Q92 0 117 41Q132 82 91 101L417 112Q448 109 439 86L113 72"
        fill="#fff7df"
        stroke="currentColor"
        strokeWidth="5"
      />
      <path d="M36 53Q64 18 91 50Q84 84 46 77Z" fill="#55d4be" />
    </svg>
  );
}

export function Panorama({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 1440 330" fill="none" aria-hidden="true">
      <defs>
        <pattern id="ro-world-pattern" width="360" height="280" patternUnits="userSpaceOnUse">
          <g stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 266H355M20 266V165H110V266M14 165L65 127L119 165M40 266V201H85V266M31 184H99M140 266V100H225V266M128 100H237M141 100L154 68H211L224 100M160 68V35H205V68M151 48H214M155 35L182 16L210 35M164 125H201V159H164ZM164 181H201V215H164Z" />
            <path d="M260 266V199H332V266M251 199Q260 172 295 170Q327 170 341 199M263 217H331M265 239H331M275 179L278 165M293 176V159M311 179L315 166" />
            <path d="M26 94Q58 71 81 93M34 99L72 100M266 63Q296 37 327 63L320 115H274Z M269 78H324M285 38Q269 21 284 5M310 37Q326 22 313 9" />
            <circle cx="110" cy="37" r="12" />
            <path d="M110 16V8M110 66V58M88 37H80M140 37H132M94 22L88 16M127 53L133 59" />
          </g>
        </pattern>
      </defs>
      <rect y="12" width="1440" height="280" fill="url(#ro-world-pattern)" />
      <path
        d="M0 290Q80 272 150 292T300 290T450 292T600 290T750 292T900 290T1050 292T1200 290T1350 292T1500 290V330H0Z"
        fill="currentColor"
      />
      <path
        d="M0 308Q50 290 100 308T200 308T300 308T400 308T500 308T600 308T700 308T800 308T900 308T1000 308T1100 308T1200 308T1300 308T1440 308"
        stroke="#fff7df"
        strokeWidth="2"
      />
    </svg>
  );
}
